
document.addEventListener('DOMContentLoaded', function () {
  const atcButtons = document.querySelectorAll('button[type="submit"]');
  const originalTexts = new WeakMap();

  atcButtons.forEach(button => {
    originalTexts.set(button, button.textContent);
  });

  let lastClickedButton = null;

  atcButtons.forEach(button => {
    button.addEventListener('click', () => {
      lastClickedButton = button;
    });
  });

  // Observa cambios en el DOM del carrito
  const cartDrawer = document.querySelector('[id*="CartDrawer"], [class*="cart-drawer"], [data-cart-drawer]');
  if (!cartDrawer) return; // Si no existe, salir

  const observer = new MutationObserver(() => {
    if (!lastClickedButton) return;

    const original = originalTexts.get(lastClickedButton) || 'Add to Cart';

    lastClickedButton.textContent = 'Added to Cart';
    lastClickedButton.disabled = true;

    setTimeout(() => {
      lastClickedButton.textContent = original;
      lastClickedButton.disabled = false;
      lastClickedButton = null;
    }, 7000);
  });

  observer.observe(cartDrawer, { childList: true, subtree: true });
});


